// University of Denver's undergraduate majors (#2652, round 2). Read on
// 2026-10-01 from the official 2026-2027 University of Denver Undergraduate
// Bulletin (bulletin.du.edu): the Major and Minor Requirements index and
// each department's Program of Study tab, which names every major and its
// degree (BA, BS, BFA, BM, BSAcc, BSBA, BSBME, BSCh, BSCpE, BSEE, BSME; the
// Bulletin's own abbreviations). Groups are the Bulletin's department pages.
// Left out: minors, concentrations (e.g. Biochemistry under the BSCh,
// Cognitive Neuroscience, the Mathematics finance and Artificial
// Intelligence concentrations), secondary majors, certificates, and pages
// that offer only a minor (Applied AI and Society, Black Studies, Judaic
// Studies, Urban Studies and others). The College of Professional Studies
// degree-completion majors (BA or BPS) are a separate last group. 87 lines.
const majors = {
    "slug": "university-of-denver",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in DU's official 2026-2027 Undergraduate Bulletin, grouped by the department page that lists it, with the degree it leads to. Minors, concentrations, secondary majors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "Accounting",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Accounting",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/accounting/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BSAcc"
                }
            ]
        },
        {
            "name": "Anthropology",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Anthropology",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/anthropology/"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Art and Art History",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Art and Art History",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/schoolofartandarthistory/"
            },
            "majors": [
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Art, Culture & Technology",
                    "degree": "BA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Pre-Art Conservation",
                    "degree": "BFA"
                },
                {
                    "name": "Studio Art",
                    "degree": "BFA"
                }
            ]
        },
        {
            "name": "Asian Studies",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Asian Studies",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/asianstudies/"
            },
            "majors": [
                {
                    "name": "Asian Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Biological Sciences",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Biological Sciences",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/biology/"
            },
            "majors": [
                {
                    "name": "Biological Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Molecular Biology",
                    "degree": "BA"
                },
                {
                    "name": "Molecular Biology",
                    "degree": "BS"
                },
                {
                    "name": "Ecology and Biodiversity",
                    "degree": "BA"
                },
                {
                    "name": "Ecology and Biodiversity",
                    "degree": "BS"
                },
                {
                    "name": "Physiology in Health & Disease",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Biomedical Engineering",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Biomedical Engineering",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/biomedicalengineering/"
            },
            "majors": [
                {
                    "name": "Biomedical Engineering",
                    "degree": "BSBME"
                }
            ]
        },
        {
            "name": "Business Information and Analytics",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Business Information and Analytics",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/businessintelligenceandanalytics/"
            },
            "majors": [
                {
                    "name": "Business Analytics",
                    "degree": "BSBA"
                }
            ]
        },
        {
            "name": "Chemistry and Biochemistry",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Chemistry and Biochemistry",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/chemistryandbiochemistry/"
            },
            "majors": [
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BSCh"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Chemistry",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Communication Studies",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Communication Studies",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/communicationsstudies/"
            },
            "majors": [
                {
                    "name": "Communication Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Computer Science",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Computer Science",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/computerscience/"
            },
            "majors": [
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Applied Computing",
                    "degree": "BA"
                },
                {
                    "name": "Game Development",
                    "degree": "BA"
                },
                {
                    "name": "Game Development",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Critical Race and Ethnic Studies",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Critical Race and Ethnic Studies",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/criticalraceandethnicstudies/"
            },
            "majors": [
                {
                    "name": "Critical Race and Ethnic Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Economics",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Economics",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/economics/"
            },
            "majors": [
                {
                    "name": "Economics",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Electrical and Computer Engineering",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Electrical and Computer Engineering",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/electricalandcomputerengineering/"
            },
            "majors": [
                {
                    "name": "Computer Engineering",
                    "degree": "BSCpE"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BSEE"
                }
            ]
        },
        {
            "name": "English and Literary Arts",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, English and Literary Arts",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/english/"
            },
            "majors": [
                {
                    "name": "English and Literary Arts",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Finance",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Finance",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/finance/"
            },
            "majors": [
                {
                    "name": "Finance",
                    "degree": "BSBA"
                }
            ]
        },
        {
            "name": "Gender, Women's and Sexuality Studies",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Gender, Women's and Sexuality Studies",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/genderandwomensstudies/"
            },
            "majors": [
                {
                    "name": "Gender, Women's and Sexuality Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Geography and the Environment",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Geography and the Environment",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/geographyandtheenvironment/"
            },
            "majors": [
                {
                    "name": "Geography",
                    "degree": "BA"
                },
                {
                    "name": "Geographic Information Science",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "Sustainability Science",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "History",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, History",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/history/"
            },
            "majors": [
                {
                    "name": "History",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Hospitality Management",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Hospitality Management",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/hospitalitymanagement/"
            },
            "majors": [
                {
                    "name": "Hospitality Management",
                    "degree": "BSBA"
                }
            ]
        },
        {
            "name": "Integrated Sciences",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Integrated Sciences",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/integrated_sciences/"
            },
            "majors": [
                {
                    "name": "Integrated Sciences",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "International Studies",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, International Studies",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/internationalstudies/"
            },
            "majors": [
                {
                    "name": "International Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Kinesiology and Sport Studies",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Kinesiology and Sport Studies",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/kinesiologyandsportstudies/"
            },
            "majors": [
                {
                    "name": "Kinesiology and Sport Studies",
                    "degree": "BA"
                },
                {
                    "name": "Kinesiology and Sport Studies",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Languages, Literatures, and Cultures",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Languages, Literatures, and Cultures",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/languagesandliteratures/"
            },
            "majors": [
                {
                    "name": "Languages, Literatures & Cultures",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Management",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Management",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/management/"
            },
            "majors": [
                {
                    "name": "International Business",
                    "degree": "BSBA"
                },
                {
                    "name": "Management",
                    "degree": "BSBA"
                }
            ]
        },
        {
            "name": "Marketing",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Marketing",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/marketing/"
            },
            "majors": [
                {
                    "name": "Marketing",
                    "degree": "BSBA"
                }
            ]
        },
        {
            "name": "Mathematics",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Mathematics",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/mathematics/"
            },
            "majors": [
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Mechanical Engineering",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Mechanical Engineering",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/mechanicalandmaterialsengineering/"
            },
            "majors": [
                {
                    "name": "Mechanical Engineering",
                    "degree": "BSME"
                }
            ]
        },
        {
            "name": "Media, Film and Journalism Studies",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Media, Film and Journalism Studies",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/mediafilmampjournalismstudies/"
            },
            "majors": [
                {
                    "name": "Film Studies and Production",
                    "degree": "BA"
                },
                {
                    "name": "Journalism Studies",
                    "degree": "BA"
                },
                {
                    "name": "Media Studies",
                    "degree": "BA"
                },
                {
                    "name": "Public Relations and Strategic Communication",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Music",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Music",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/music/"
            },
            "majors": [
                {
                    "name": "Applied Music",
                    "degree": "BA"
                },
                {
                    "name": "Music Studies",
                    "degree": "BA"
                },
                {
                    "name": "Composition",
                    "degree": "BM"
                },
                {
                    "name": "Jazz Studies and Commercial Music",
                    "degree": "BM"
                },
                {
                    "name": "Performance",
                    "degree": "BM"
                },
                {
                    "name": "Recording and Production",
                    "degree": "BM"
                }
            ]
        },
        {
            "name": "Philosophy",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Philosophy",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/philosophy/"
            },
            "majors": [
                {
                    "name": "Philosophy",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Physics and Astronomy",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Physics and Astronomy",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/physicsandastronomy/"
            },
            "majors": [
                {
                    "name": "Physics and Astronomy",
                    "degree": "BA"
                },
                {
                    "name": "Physics and Astronomy",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Political Science",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Political Science",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/politicalscience/"
            },
            "majors": [
                {
                    "name": "Political Science",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Psychology",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Psychology",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/psychology/"
            },
            "majors": [
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Public Policy",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Public Policy",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/publicpolicy/"
            },
            "majors": [
                {
                    "name": "Public Policy",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Real Estate & the Built Environment",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Real Estate & the Built Environment",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/realestateandconstructionmanagement/"
            },
            "majors": [
                {
                    "name": "Real Estate and the Built Environment",
                    "degree": "BSBA"
                }
            ]
        },
        {
            "name": "Religious Studies",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Religious Studies",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/religiousstudies/"
            },
            "majors": [
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Socio-Legal Studies",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Socio-Legal Studies",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/socio-legal_studies/"
            },
            "majors": [
                {
                    "name": "Socio-Legal Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Sociology and Criminology",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Sociology and Criminology",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/sociologyandcriminology/"
            },
            "majors": [
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Criminology",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Spanish Language, Literary, and Cultural Studies",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Spanish Language, Literary, and Cultural Studies",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/spanish/"
            },
            "majors": [
                {
                    "name": "Spanish Language, Literary, and Cultural Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Theatre",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Theatre",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/traditionalbachelorsprogrammajorandminors/theatre/"
            },
            "majors": [
                {
                    "name": "Theatre",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Professional Studies Bachelor Completion Programs",
            "source": {
                "label": "DU 2026-2027 Undergraduate Bulletin, Major and Minor Requirements",
                "url": "https://bulletin.du.edu/undergraduate/majorsminorscoursedescriptions/"
            },
            "note": "Degree-completion programs for adult students, offered as a Bachelor of Arts or a Bachelor of Professional Studies; first-year students apply to the traditional bachelor's program above.",
            "majors": [
                {
                    "name": "Communication Arts",
                    "degree": "BA"
                },
                {
                    "name": "Communication Arts",
                    "degree": "BPS"
                },
                {
                    "name": "Healthcare Administration",
                    "degree": "BA"
                },
                {
                    "name": "Healthcare Administration",
                    "degree": "BPS"
                },
                {
                    "name": "Information Technology",
                    "degree": "BA"
                },
                {
                    "name": "Information Technology",
                    "degree": "BPS"
                },
                {
                    "name": "Organizational Leadership",
                    "degree": "BA"
                },
                {
                    "name": "Organizational Leadership",
                    "degree": "BPS"
                },
                {
                    "name": "Transportation and Supply Chain",
                    "degree": "BA"
                },
                {
                    "name": "Transportation and Supply Chain",
                    "degree": "BPS"
                }
            ]
        }
    ]
};

export default majors;
